// extracted by mini-css-extract-plugin
export default {"header":"BAQ9QdgO_9p0EUalOJoY","container":"WpZIQDu3PsTMml1FMCVX","question":"aAL4MT8u4vhLEkMlA39P"};